import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { withPrefix } from "gatsby";
import { ThemeProvider } from "styled-components";
import { setConfiguration, useScreenClass } from "react-grid-system";

import { defineCustomElements as deckDeckGoHighlightElement } from "@deckdeckgo/highlight-code/dist/loader";

import Footer from "../Footer";
import Header from "../Header";
import ReactImageVideoLightbox from "../ReactImageVideoLightbox";

import lightTheme from "../../../src/styles/themes/light";
import darkTheme from "../../../src/styles/themes/dark";
import { GlobalStyle } from "../../../src/styles/global";

import HeaderBarContext from "../../context/HeaderBarContext";
import LighboxContext from "../../context/LighboxContext";

import { ExternalContainer, InternalContainer } from "./styles";

deckDeckGoHighlightElement();

const TemplateWrapper = ({ theme, title, description, children, noPadding }) => {
  const screenClass = useScreenClass();

  const { opened } = useContext(HeaderBarContext);
  const { openLightbox } = useContext(LighboxContext);

  const themeToBeUsed = theme === "dark" ? darkTheme : lightTheme;
  const windowGlobal = typeof window !== "undefined" && window;
  if (!windowGlobal) {
    return <></>;
  }

  const largeScreen =
    window.outerWidth > 600 ||
    ["lg", "xl", "xxl", "xxxl"].includes(screenClass);
  setConfiguration({ gutterWidth: 0 });

  return (
    <ThemeProvider theme={themeToBeUsed}>
      <GlobalStyle />
      <div id="mainGatsbyContainer">
        <Helmet>
          <html lang="en" />
          <title>{title || "Constellation Network"}</title>
          <meta
            name="description"
            content={description || "Constellation Network Website"}
          />

          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href={`${withPrefix("/")}img/apple-touch-icon.png`}
          />
          <link
            rel="icon"
            type="image/png"
            href={`${withPrefix("/")}img/favicon-32x32.png`}
            sizes="32x32"
          />
          <link
            rel="icon"
            type="image/png"
            href={`${withPrefix("/")}img/favicon-16x16.png`}
            sizes="16x16"
          />

          <link
            rel="mask-icon"
            href={`${withPrefix("/")}img/apple-touch-icon.png`}
            color="#ff4400"
          />
          <meta name="theme-color" content="#fff" />
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
          <link
            href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&family=Inter:wght@100..900&display=swap"
            rel="stylesheet"
          />
          <link href="/fonts/TWKLausanne/TWKLausanne.css" rel="stylesheet" />
          <meta property="og:type" content="business.business" />
          <meta property="og:title" content={title} />
          <meta property="og:url" content="/" />
          <meta
            property="og:image"
            content={`${withPrefix("/")}img/apple-touch-icon.png`}
          />
          <style id="toast">
            {`
            .react-local-toast  {
              background: #1B1E29 !important;

              span {
                color: #FFF !important;
              }
            }
             `}
          </style>
          <meta name="referrer" content="strict-origin-when-cross-origin" />
          <script
            src="https://api.concord.tech/site-v1/site-client/c50ce2b4-eb2d-4568-8b37-8c848107dd5c"
            async
          ></script>
          <script src="https://embed.typeform.com/next/embed.js"></script>
        </Helmet>
        {!openLightbox ? (
          <>
            <Header />
            {!opened && (
              <>
                <ExternalContainer>
                  <InternalContainer largeScreen={largeScreen} noPadding={noPadding}>
                    {children}
                  </InternalContainer>
                </ExternalContainer>
                <Footer />
              </>
            )}
          </>
        ) : (
          <ReactImageVideoLightbox />
        )}
      </div>
    </ThemeProvider>
  );
};

export default TemplateWrapper;
